export default "__VITE_ASSET__CZwRBdZI__"